module.exports = __webpack_public_path__ + "img/image-gallery-cone.fc980172.jpg";